import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
import { APIResponse } from "./CommonApiSlice";
import { QuestionSolution } from "@src/pages/batches/elp-report-question-details/ElpReportQuestionDeatils";

interface AddChapterPayload {
  name: string;
  duration: number;
  description: string | undefined;
}

export interface ChapterItem {
  createdOn: string;
  lastUpdateOn: string;
  createdByName: string;
  createdByEmail: string;
  modifiedByName: string;
  modifiedByEmail: string;
  id: string;
  name: string;
  duration: number;
  subjectId: string;
  parentId: string;
  description: string;
  weight: number;
  type: string;
  searchKey: string;
}

export interface GetAllChaptersResponse extends APIResponse {
  response: ChapterItem[];
}
export interface GetAllReportQuestionResponse extends APIResponse {
  response: QuestionSolution[];
}
export type AddChaptersResponse = APIResponse;
export type UpdateChaptersResponse = APIResponse;

export const ChapterApiSlice = createApi({
  reducerPath: "chapterApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllChapters: builder.query<
      GetAllChaptersResponse,
      { subjectId: string }
    >({
      query: ({ subjectId }) => ({
        url: `chapter/get?subjectId=${subjectId}`,
        method: "GET",
      }),
    }),
    getQuestionForStudentElpReport: builder.query<
      GetAllReportQuestionResponse,
      { parentId:string,parentType:string,batchId:string,studentId:string }
    >({
      query: ({parentId,parentType,batchId,studentId}) => ({
        url: `chapter/student-answer-response?parentId=${parentId}&parentType=${parentType}&batchId=${batchId}&studentId=${studentId}`,
        method: "GET",
      }),
    }),
    addChapters: builder.mutation<
      AddChaptersResponse,
      { payload: AddChapterPayload & { parentId?: string }; subjectId: string; parentId?: string }
    >({
      query: ({ subjectId, payload, parentId }) => {
        let url = `chapter/add`;
        if (parentId || subjectId) {
          url += `?parentId=${parentId || subjectId}`;
        }
        return {
          url,
          method: "POST",
          body: payload,
        };
      },
    }),
    updateChapter: builder.mutation<
      UpdateChaptersResponse,
      { chapterId: string; payload: { [key: string]: string } }
    >({
      query: ({ chapterId, payload }) => ({
        url: `chapter?chapterId=${chapterId}`,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
});

export const {
  useAddChaptersMutation,
  useLazyGetAllChaptersQuery,
  useUpdateChapterMutation,
  useGetQuestionForStudentElpReportQuery,
} = ChapterApiSlice;
